import { clearOktaSessionInfo, getOktaBearerToken } from 'helpers/okta-session';
import { UNAUTHORIZED, NOT_FOUND } from 'constants/error-types';
import Notification from 'components/partials/notification/notification.helper';

/**
 * Handles expired user sessions by clearing session info and redirecting to login
 * @param {string} title - Notification title
 * @param {string} message - Notification message
 * @param {string} type - Notification type
 */
const sessionExpiredHandler = (
  title = 'Session Expired',
  message = 'Your session has expired, please log in again.',
  type = 'info'
) => {
  clearOktaSessionInfo();
  Notification.flash(title, type, message);
  window.location.href = '/login';
};

/**
 * Intercepts and handles API errors
 * @param {Object} error - Error object from API call
 * @returns {Promise} Rejected promise with error details
 */
export const errorInterceptors = (error = {}) => {
  const { status, statusText, data } = error?.response || {};

  if (!getOktaBearerToken()) {
    sessionExpiredHandler();

    return Promise.reject(
      Object.assign(new Error('Unauthorized: No bearer token'), {
        status,
        statusText,
        data,
      })
    );
  }

  if (status && status === UNAUTHORIZED) {
    sessionExpiredHandler();
  } else if (
    status &&
    data &&
    status === NOT_FOUND &&
    data.detail === 'Subscription not active'
  ) {
    sessionExpiredHandler(
      'Error logging in',
      `Your school's subscription is locked.`,
      'error'
    );
  } else if (error.response) {
    console.error('API response error', error.response);
  }

  return Promise.reject(
    Object.assign(new Error(`API Error: ${statusText || 'Unknown error'}`), {
      status,
      statusText,
      data,
    })
  );
};
